export default __webpack_public_path__ + "static/media/plus.e00803b5.svg";